module.exports = __webpack_public_path__ + "static/media/da.cd5a205d.png";